module.exports = __webpack_public_path__ + "static/media/recycle-bin-selected.ee5856f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/recycle-bin-selected.svg
// module id = 390
// module chunks = 0